import { api } from './apiClient';

export interface Department {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

class DepartmentService {
  /**
   * Fetch active departments from tenant-admin API.
   * apiClient interceptor sets Authorization + X-Tenant-Id from localStorage.
   */
  async getAllDepartments(): Promise<Department[]> {
    const response = await api.get<{ success?: boolean; data?: Department[] } | Department[]>('/departments');

    if (!response.isSuccess) {
      throw new Error(response.message || 'Failed to load departments');
    }

    if (Array.isArray(response.data)) {
      return response.data;
    }

    if (response.data && (response.data as any).data) {
      return (response.data as any).data as Department[];
    }

    return [];
  }

  /**
   * Same catalog, unauthenticated — for the pre-signup Company Registration
   * form (accept-invitation) which runs before any JWT exists.
   */
  async getAllDepartmentsPublic(): Promise<Department[]> {
    const response = await api.get<{ success?: boolean; data?: Department[] } | Department[]>('/departments/public');

    if (!response.isSuccess) {
      throw new Error(response.message || 'Failed to load departments');
    }

    if (Array.isArray(response.data)) {
      return response.data;
    }

    if (response.data && (response.data as any).data) {
      return (response.data as any).data as Department[];
    }

    return [];
  }
}

export default new DepartmentService();
